export default __webpack_public_path__ + "static/media/bannerXmas.27be8223.png";